import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { useEffect } from "react";

import { t } from "@/i18n-js/instance";
import { PlansProvider } from "@/react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

import { LeftPane } from "./LeftPane";
import { RightPane } from "./RightPane";

const I18N_ROOT = "pricing_plans.upgrade_modal.enterprise_plus";

interface EnterprisePlusModalUIKitComponentProps {
  onClose?: () => void | Promise<void>;
  source?: string;
}

export const EnterprisePlusModalUIKitComponent = ({
  onClose,
  source,
}: EnterprisePlusModalUIKitComponentProps) => {
  const modal = useModal();
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("enterprise_plus_modal.viewed", { source });
  }, [trackEvent, source]);

  const handleClose = async () => {
    if (onClose) {
      await onClose();
    }
    await modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleClose}>
      <Modal.Overlay />
      <Modal.Content size="full" className="!max-w-[1024px] sm:!h-auto">
        <Modal.Header className="pt-8">
          <Modal.Title>{t(`${I18N_ROOT}.title`)}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleClose} />
          </Modal.HeaderActions>
        </Modal.Header>

        <Modal.Body className="pb-8">
          <PlansProvider>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-10">
              <div className="order-2 pt-5 md:order-1">
                <LeftPane />
              </div>
              <div className="order-1 md:order-2">
                <RightPane source={source} />
              </div>
            </div>
          </PlansProvider>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
